export enum TrackingEvent {
  ReportListOpen = `Report list - open`,
  PresenceViewsLoaded = `Presence views loaded`,
  OverflowMenuClicked = `Overflow menu clicked`,
  OverflowMenuActionSelected = `Overflow menu action selected`,
  // TODO: stop tracking this in report header in favor of ReportEditor
  ReportSaved = `Report saved`,

  DuplicateClicked = `Duplicate clicked`,

  // Boards specific events
  LinkOnDashboard = `Link on Dashboard`,
  ReturnToBoard = `Return to Board`,
  // TODO: stop tracking these in report header in favor of ReportEditor
  StartSave = `Start Save`,
  StartReportDuplicate = `Start Report Duplicate`,
  StartReportRename = `Start Report Rename`,
  StartReportDelete = `Start Report Delete`,
  StartReportEditDescription = `Start Report Edit Description`,
}

export enum SaveTypeTrackingProperty {
  /** Saving a new Report from blank */
  New = `New`,
  /** Saving a new Report from duplicate parameters from an existing report (Duplicate button) */
  Duplicated = `Duplicated`,
  /** Saving an existing report */
  Existing = `Existing`,
  /** Renaming an existing report */
  Renamed = `Renamed`,
  /** Starting from an existing report, saving a new one (Save as new button) */
  SaveAsNew = `SaveAsNew`,
}
